import { useState } from "react";
import { Icon, Notice } from "../ui";
import { PinPad } from "../ui/PinPad";
import { usePin, type GeraetDaten } from "./api";
import { ApiFehler } from "../api/client";

const ROLLE: Record<string, string> = { inhaber: "Inhaber", mitarbeiter: "Mitarbeiter", aushilfe: "Aushilfe" };

/** Person wählen, dann PIN – nach der letzten Ziffer geht es direkt zur Kasse. */
export function WerKassiert({ daten }: { daten: GeraetDaten }) {
  const eingeteilt = new Set(daten.eingeteilt ?? []);
  const personen = (daten.personen ?? []).filter((p) => p.pinGesetzt).sort((a, b) => Number(eingeteilt.has(b.id)) - Number(eingeteilt.has(a.id)));
  const ohnePin = (daten.personen ?? []).filter((p) => !p.pinGesetzt);
  const [gewaehlt, setGewaehlt] = useState<string | null>(personen[0]?.id ?? null);
  const [fehler, setFehler] = useState<string | null>(null);
  const pin = usePin();
  const person = personen.find((p) => p.id === gewaehlt);

  return (
    <div className="kasse-center">
      <div className="sc-col" style={{ gap: 4, alignItems: "center" }}>
        <h1 className="display">Wer kassiert?</h1>
        <p className="sc-muted">Person wählen, dann PIN eingeben.</p>
      </div>
      {personen.length === 0 ? (
        <Notice tone="attention" title="Noch keine PIN vergeben">
          In der Verwaltung unter Einstellungen › Personal eine PIN für die Person setzen, die kassiert.
        </Notice>
      ) : (
        <>
          <div className="sc-tiles" role="radiogroup" aria-label="Person">
            {personen.map((p) => (
              <button
                key={p.id}
                type="button"
                className="sc-tile"
                aria-pressed={p.id === gewaehlt}
                onClick={() => {
                  setGewaehlt(p.id);
                  setFehler(null);
                }}
              >
                <span className="sc-avatar" aria-hidden="true">
                  {p.name.charAt(0).toUpperCase()}
                </span>
                <span className="sc-col" style={{ gap: 0 }}>
                  <span className="sc-strong">{p.name}</span>
                  <span className="sc-muted sc-small">{ROLLE[p.rolle] ?? p.rolle}{eingeteilt.has(p.id) ? " · heute eingeteilt" : ""}</span>
                </span>
              </button>
            ))}
          </div>
          {person ? (
            <PinPad
              key={person.id}
              label={`PIN für ${person.name}`}
              error={fehler ?? undefined}
              disabled={pin.isPending}
              onComplete={async (wert) => {
                setFehler(null);
                try {
                  await pin.mutateAsync({ benutzerId: person.id, pin: wert });
                } catch (err) {
                  setFehler(err instanceof ApiFehler ? err.message : "PIN stimmt nicht. Noch einmal.");
                }
              }}
            />
          ) : null}
        </>
      )}
      {ohnePin.length ? (
        <p className="sc-muted sc-small">
          <Icon name="info" size={16} /> Ohne PIN: {ohnePin.map((p) => p.name).join(", ")}
        </p>
      ) : null}
      <p className="sc-muted sc-small">
        <Icon name="store" size={16} /> {daten.laden?.name} · {daten.geraet?.name}
      </p>
    </div>
  );
}
